// extracted by mini-css-extract-plugin
module.exports = {"box":"Posts_box__3twi_"};